import gql from 'graphql-tag'

export const QUERY = gql`
  query resources_index($page: Int!, $perPage: Int!) {
    resources(page: $page, perPage: $perPage) {
      nodes {
        id
        title
      }
      totalCount
      pageInfo {
        hasNextPage
        totalCount
      }
    }
  }
`
